import React from "react";
import Product from "./product";
import Comparison from "./comparison";
import Sort from "./sorting";

class Products extends React.Component {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }
  onClick() {
    this.props.handleSearch("", this.props.results.length + 18);
  }
  render() {
    if (this.props.total) {
      var total = (
        <div className="products-summary__total">
          <span>{this.props.total}</span> Products
        </div>
      );
    }

    if (this.props.results.length !== this.props.total) {
      var loadMoreBtn = (
        <div className="load-more-products" onClick={this.onClick}>
          Load More Products
        </div>
      );
    }
    return (
      <div className="products">
        <div className="products-summary">
          {total}
          <Sort handleSearch={this.props.handleSearch} />
        </div>
        <Comparison />
        {_.chunk(this.props.results, 3).map((row, i) => {
          return (
            <div className="product-row" key={i}>
              {_.map(row, (product, index) => {
                return (
                  <div className="product-row__item" key={index}>
                    <Product data={product} />
                  </div>
                );
              })}
            </div>
          );
        })}
        {loadMoreBtn}
        <div className="scroll-to-top">
          <div>
            <i className="material-icons">&#xE316;</i>
          </div>
        </div>
      </div>
    );
  }
}

export { Products as default };
